var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompaniesDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_242_96964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 18.333L1.66666 18.333",
    stroke: "#DEDEDE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.3337V5.00033C17.5 3.42898 17.5 2.6433 17.0118 2.15515C16.5237 1.66699 15.738 1.66699 14.1667 1.66699H12.5C10.9287 1.66699 10.143 1.66699 9.65482 2.15515C9.26187 2.5481 9.18523 3.13384 9.17029 4.16699",
    stroke: "#DEDEDE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.3337V7.50033C12.5 5.92898 12.5 5.1433 12.0118 4.65515C11.5237 4.16699 10.738 4.16699 9.16667 4.16699H5.83333C4.26198 4.16699 3.47631 4.16699 2.98816 4.65515C2.5 5.1433 2.5 5.92898 2.5 7.50033V18.3337",
    stroke: "#DEDEDE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.333V15.833",
    stroke: "#DEDEDE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6.66699H10",
    stroke: "#DEDEDE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9.16699H10",
    stroke: "#DEDEDE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11.667H10",
    stroke: "#DEDEDE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_96964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesDark);
export default __webpack_public_path__ + "static/media/Companies Dark.ffe227b9d51dc670d669fec997b483e0.svg";
export { ForwardRef as ReactComponent };